import Vuex from 'vuex';
import { shallowMount, createLocalVue } from "@vue/test-utils";
import InvoiceItem from './InvoiceItem';
import constants from '../../../../../store/modules/constants';

const invoiceItemTags = constants.state.invoiceItemTags;

const localVue = createLocalVue();
localVue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    constants
  }
});

const createWrapper = (item) => {
  return shallowMount(InvoiceItem, {
    store,
    localVue,
    propsData: { item }
  });
};

let item = {
  subscription_id: 123,
  subscription: 0,
  product: {
    name: 'Product 1',
    imagery: {},
    productType: 'some-type',
  }
};

describe('InvoiceItem', () => {
  test('general snapshot', () => {
    let wrapper = createWrapper(item);
    expect(wrapper.html()).toMatchSnapshot();
  });

  describe('computed', () => {
    describe('pillText', () => {

      test('return SUBSCRIPTION when item has truthy subscription property', () => {
        const localState = {
          item: {
            subscription: 6
          },
          invoiceItemTags
        };
        expect(InvoiceItem.computed.pillText.call(localState)).toEqual('SUBSCRIPTION');
      });

      test('return nothing when item has falsey subscription property', () => {
        const localState = {
          item: {
            subscription: 0
          },
          invoiceItemTags
        };
        expect(InvoiceItem.computed.pillText.call(localState)).toEqual(undefined);
      });

      test('return SUBSCRIPTION ADD-ON when item has truthy subscription_id property', () => {
        const localState = {
          item: {
            subscription: 0,
            subscription_id: 123
          },
          invoiceItemTags
        };
        expect(InvoiceItem.computed.pillText.call(localState)).toEqual('SUBSCRIPTION ADD-ON');
      });

      test('return SUBSCRIPTION ADD-ON when item has truthy sub_id property', () => {
        const localState = {
          item: {
            subscription: 0,
            sub_id: 123
          },
          invoiceItemTags
        };
        expect(InvoiceItem.computed.pillText.call(localState)).toEqual('SUBSCRIPTION ADD-ON');
      });

    });
  });
});
